const form = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        margin: '4px 0 0',
        fontSize: '0.75rem',
        lineHeight: 1.2,
      },
    },
  },
};
export default form;
